import * as categoriesActions from './categoriesActions';
import categoriesReducer from './categoriesReducer';
import categoriesSagas, { categoriesDumpUpdater, categoriesNudgeUpdater } from './categoriesSagas';
import * as categoriesSelectors from './categoriesSelectors';
import * as categoriesTransformers from './categoriesTransformers';
import * as categoriesTypes from './categoriesTypes';
import * as categoriesUtils from './categoriesUtils';
import * as categoryFormBuilder from './categoryFormBuilder';

const { CATEGORIES_REDUCER_KEY } = categoriesTypes;
const CATEGORIES_VERSION_NUMBER = 4;

export {
  CATEGORIES_REDUCER_KEY,
  CATEGORIES_VERSION_NUMBER,
  categoriesActions,
  categoriesDumpUpdater,
  categoriesNudgeUpdater,
  categoriesReducer,
  categoriesSagas,
  categoriesSelectors,
  categoriesTransformers,
  categoriesTypes,
  categoriesUtils,
  categoryFormBuilder,
};
